import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { useTranslation } from "localization/translation";
import { Lang } from "components";
import useStore from "context";

const FeaturesModal = ({
  title,
  accept,
  close,
  isOpen,
  loading,
  feature,
  handleChange,
}) => {
  const translation = useTranslation();

  const { lang } = useStore();

  return (
    <Dialog
      classes={{
        paper: `modal-content rounded-lg`,
      }}
      open={isOpen}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={accept}>
        <DialogTitle className="px-4">{title}</DialogTitle>
        <Lang />
        <div className="px-4">
          <div className="my-3">
            <TextField
              id="outlined-basic"
              label={translation.name}
              variant="outlined"
              value={feature?.[`name_${lang}`]}
              type="text"
              className="w-full"
              onChange={(e) => handleChange(`name_${lang}`, e.target.value)}
            />
          </div>
        </div>
        <DialogActions className="d-flex mx-auto p-4">
          <Button
            onClick={close}
            variant="contained"
            type="button"
            className=""
          >
            {translation.no}
          </Button>
          <Button
            color="secondary"
            type="submit"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : translation.yes}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default FeaturesModal;


